// Generated by CoffeeScript 2.3.2

import Solver from './Solver'

import AccuseDialog from './AccuseDialog'
import CommlinkDialog from './CommlinkDialog'
import ConfirmDialog from './ConfirmDialog'
import ExportDialog from './ExportDialog'
import HandDialog from './HandDialog'
import ImportDialog from './ImportDialog'
import LogDialog from './LogDialog'
import MainMenu from './MainMenu'
import MainView from './MainView'
import React, { Component } from 'react';
import SetupDialog from './SetupDialog'
import ShowDialog from './ShowDialog'
import SuggestDialog from './SuggestDialog'
;
var App, classic, configurations, haunted_mansion, master_detective, star_wars,
  boundMethodCheck = function(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new Error('Bound instance method accessed before binding'); } };

classic = {
  name: "Classic",
  rulesId: "classic",
  minPlayers: 3,
  maxPlayers: 6,
  types: {
    suspect: {
      title: "Suspects",
      preposition: "",
      article: ""
    },
    weapon: {
      title: "Weapons",
      preposition: "with ",
      article: "the "
    },
    room: {
      title: "Rooms",
      preposition: "in ",
      article: "the "
    }
  },
  cards: {
    mustard: {
      name: "Colonel Mustard",
      type: "suspect"
    },
    white: {
      name: "Mrs. White",
      type: "suspect"
    },
    plum: {
      name: "Professor Plum",
      type: "suspect"
    },
    peacock: {
      name: "Mrs. Peacock",
      type: "suspect"
    },
    green: {
      name: "Mr. Green",
      type: "suspect"
    },
    scarlet: {
      name: "Miss Scarlet",
      type: "suspect"
    },
    revolver: {
      name: "Revolver",
      type: "weapon"
    },
    knife: {
      name: "Knife",
      type: "weapon"
    },
    rope: {
      name: "Rope",
      type: "weapon"
    },
    pipe: {
      name: "Lead pipe",
      type: "weapon"
    },
    wrench: {
      name: "Wrench",
      type: "weapon"
    },
    candlestick: {
      name: "Candlestick",
      type: "weapon"
    },
    dining: {
      name: "Dining Room",
      type: "room"
    },
    conservatory: {
      name: "Conservatory",
      type: "room"
    },
    kitchen: {
      name: "Kitchen",
      type: "room"
    },
    study: {
      name: "Study",
      type: "room"
    },
    library: {
      name: "Library",
      type: "room"
    },
    billiard: {
      name: "Billiards Room",
      type: "room"
    },
    lounge: {
      name: "Lounge",
      type: "room"
    },
    ballroom: {
      name: "Ballroom",
      type: "room"
    },
    hall: {
      name: "Hall",
      type: "room"
    }
  },
  suggestionOrder: ["suspect", "weapon", "room"]
};

master_detective = {
  name: "Master Detective",
  rulesId: "master",
  minPlayers: 3,
  maxPlayers: 10,
  types: {
    suspect: {
      title: "Suspects",
      preposition: "",
      article: ""
    },
    weapon: {
      title: "Weapons",
      preposition: "with ",
      article: "the "
    },
    room: {
      title: "Rooms",
      preposition: "in ",
      article: "the "
    }
  },
  cards: {
    mustard: {
      name: "Colonel Mustard",
      type: "suspect"
    },
    white: {
      name: "Mrs. White",
      type: "suspect"
    },
    plum: {
      name: "Professor Plum",
      type: "suspect"
    },
    peacock: {
      name: "Mrs. Peacock",
      type: "suspect"
    },
    green: {
      name: "Mr. Green",
      type: "suspect"
    },
    scarlet: {
      name: "Miss Scarlet",
      type: "suspect"
    },
    rose: {
      name: "Madame Rose",
      type: "suspect"
    },
    gray: {
      name: "Sergeant Gray",
      type: "suspect"
    },
    brunette: {
      name: "Monsieur Brunette",
      type: "suspect"
    },
    peach: {
      name: "Miss Peach",
      type: "suspect"
    },
    revolver: {
      name: "Revolver",
      type: "weapon"
    },
    knife: {
      name: "Knife",
      type: "weapon"
    },
    rope: {
      name: "Rope",
      type: "weapon"
    },
    pipe: {
      name: "Pipe",
      type: "weapon"
    },
    wrench: {
      name: "Wrench",
      type: "weapon"
    },
    candlestick: {
      name: "Candlestick",
      type: "weapon"
    },
    poison: {
      name: "Poison",
      type: "weapon"
    },
    horseshoe: {
      name: "Horseshoe",
      type: "weapon"
    },
    dining: {
      name: "Dining Room",
      type: "room"
    },
    conservatory: {
      name: "Conservatory",
      type: "room"
    },
    kitchen: {
      name: "Kitchen",
      type: "room"
    },
    studio: {
      name: "Studio",
      type: "room"
    },
    library: {
      name: "Library",
      type: "room"
    },
    billiard: {
      name: "Billiard Room",
      type: "room"
    },
    courtyard: {
      name: "Courtyard",
      type: "room"
    },
    gazebo: {
      name: "Gazebo",
      type: "room"
    },
    drawing: {
      name: "Drawing Room",
      type: "room"
    },
    carriage: {
      name: "Carriage House",
      type: "room"
    },
    trophy: {
      name: "Trophy Room",
      type: "room"
    },
    fountain: {
      name: "Fountain",
      type: "room"
    }
  },
  suggestionOrder: ["suspect", "weapon", "room"]
};

haunted_mansion = {
  name: "Haunted Mansion",
  rulesId: "classic",
  minPlayers: 3,
  maxPlayers: 6,
  types: {
    guest: {
      title: "Guests",
      preposition: "haunted ",
      article: ""
    },
    ghost: {
      title: "Ghosts",
      preposition: "",
      article: "the "
    },
    room: {
      title: "Rooms",
      preposition: "in ",
      article: "the "
    }
  },
  cards: {
    pluto: {
      name: "Pluto",
      type: "guest"
    },
    daisy: {
      name: "Daisy Duck",
      type: "guest"
    },
    goofy: {
      name: "Goofy",
      type: "guest"
    },
    donald: {
      name: "Donald Duck",
      type: "guest"
    },
    minnie: {
      name: "Minnie Mouse",
      type: "guest"
    },
    mickey: {
      name: "Mickey Mouse",
      type: "guest"
    },
    prisoner: {
      name: "Prisoner",
      type: "ghost"
    },
    singer: {
      name: "Opera Singer",
      type: "ghost"
    },
    bride: {
      name: "Bride",
      type: "ghost"
    },
    traveler: {
      name: "Traveler",
      type: "ghost"
    },
    mariner: {
      name: "Mariner",
      type: "ghost"
    },
    skeleton: {
      name: "Candlestick",
      type: "ghost"
    },
    graveyard: {
      name: "Graveyard",
      type: "room"
    },
    seance: {
      name: "Seance Room",
      type: "room"
    },
    ballroom: {
      name: "Ballroom",
      type: "room"
    },
    attic: {
      name: "Attic",
      type: "room"
    },
    mausoleum: {
      name: "Mausoleum",
      type: "room"
    },
    conservatory: {
      name: "Conservatory",
      type: "room"
    },
    library: {
      name: "Library",
      type: "room"
    },
    foyer: {
      name: "Foyer",
      type: "room"
    },
    chamber: {
      name: "Portrait Chamber",
      type: "room"
    }
  },
  suggestionOrder: ["ghost", "guest", "room"]
};

star_wars = {
  name: "Clue: Star Wars Edition",
  rulesId: "star_wars",
  minPlayers: 3,
  maxPlayers: 6,
  types: {
    planet: {
      title: "Planets",
      preposition: "Darth Vader is targeting ",
      article: ""
    },
    room: {
      title: "Rooms",
      preposition: ", the plans are in ",
      article: "the "
    },
    ship: {
      title: "Ships",
      preposition: ", and we can escape in ",
      article: "a "
    }
  },
  cards: {
    alderaan: {
      name: "Alderaan",
      type: "planet"
    },
    bespin: {
      name: "Bespin",
      type: "planet"
    },
    dagobah: {
      name: "Dagobah",
      type: "planet"
    },
    endor: {
      name: "Endor",
      type: "planet"
    },
    tattoine: {
      name: "Tatooine",
      type: "planet"
    },
    yavin: {
      name: "Yavin 4",
      type: "planet"
    },
    millenium: {
      name: "Millenium Falcon",
      type: "ship"
    },
    xwing: {
      name: "X-Wing",
      type: "ship"
    },
    ywing: {
      name: "Y-Wing",
      type: "ship"
    },
    tiefighter: {
      name: "Tie Fighter",
      type: "ship"
    },
    pod: {
      name: "Escape Pod",
      type: "ship"
    },
    tiebomber: {
      name: "Tie Bomber",
      type: "ship"
    },
    laser: {
      name: "Laser Control Room",
      type: "room"
    },
    overbridge: {
      name: "Overbridge",
      type: "room"
    },
    docking: {
      name: "Docking Bay",
      type: "room"
    },
    red: {
      name: "Red Control Room",
      type: "room"
    },
    war: {
      name: "War Room",
      type: "room"
    },
    detention: {
      name: "Detention Block",
      type: "room"
    },
    throne: {
      name: "Throne Room",
      type: "room"
    },
    trash: {
      name: "Trash Compactor",
      type: "room"
    },
    tractor: {
      name: "Tractor Beam Generator",
      type: "room"
    }
  },
  suggestionOrder: ["planet", "room", "ship"]
};

configurations = {
  classic: classic,
  master_detective: master_detective,
  haunted_mansion: haunted_mansion,
  star_wars: star_wars
};

App = class App extends Component {
  constructor(props) {
    super(props);
    // Component launchers
    this.showMainMenu = this.showMainMenu.bind(this);
    this.showNewGameDialog = this.showNewGameDialog.bind(this);
    this.showImportDialog = this.showImportDialog.bind(this);
    this.showLog = this.showLog.bind(this);
    this.showExportDialog = this.showExportDialog.bind(this);
    this.showConfirmDialog = this.showConfirmDialog.bind(this);
    this.showHandDialog = this.showHandDialog.bind(this);
    this.showSuggestDialog = this.showSuggestDialog.bind(this);
    this.showShowDialog = this.showShowDialog.bind(this);
    this.showAccuseDialog = this.showAccuseDialog.bind(this);
    this.showCommlinkDialog = this.showCommlinkDialog.bind(this);
    // Callbacks
    this.handleConfirmDialogClose = this.handleConfirmDialogClose.bind(this);
    this.solver = null;
    this.accusationId = 1;
    this.commlinkId = 1;
    this.suggestionId = 1;
    this.state = {
      playerIds: [],
      configurationId: "master_detective",
      log: [],
      mainMenuAnchor: null,
      newGameDialogOpen: false,
      logDialogOpen: false,
      confirmDialog: {
        open: false,
        title: '',
        question: '',
        yesAction: null,
        noAction: null
      },
      handDialogOpen: false,
      suggestDialogOpen: false,
      showDialogOpen: false,
      accuseDialogOpen: false
    };
    return;
  }

  newGame(configurationId, playerIds) {
    this.solver = new Solver(configurations[configurationId], playerIds);
    this.accusationId = 1;
    this.suggestionId = 1;
    this.setState({
      playerIds: playerIds,
      configurationId: configurationId,
      log: [this.setupLogEntry(configurationId, playerIds)]
    });
  }

  importLog(imported) {
    var accuser, caller, card, cards, entry, i, importedLog, len, outcome, player, receiver, ref, setup, showed, suggester;
    importedLog = JSON.parse(imported);
    if (importedLog.length === 0) {
      this.solver = null;
      return;
    }
    setup = importedLog[0].setup;
    this.newGame(setup.variation, setup.players);
    ref = importedLog.slice(1);
    for (i = 0, len = ref.length; i < len; i++) {
      entry = ref[i];
      if (entry.hand != null) {
        ({player, cards} = entry.hand);
        this.recordHand(player, cards);
      } else if (entry.suggest != null) {
        ({suggester, cards, showed} = entry.suggest);
        this.recordSuggestion(suggester, cards, showed);
      } else if (entry.show != null) {
        ({player, card} = entry.show);
        this.recordShow(player, card);
      } else if (entry.accuse != null) {
        ({accuser, cards, outcome} = entry.accuse);
        this.recordAccusation(accuser, cards, outcome);
      } else if ((entry.commlink != null) && setup.variation === "star_wars") {
        ({caller, receiver, cards, showed} = entry.commlink);
        this.recordCommlink(caller, receiver, cards, showed);
      } else {
        console.log(`Imported unsupported log entry: ${JSON.stringify(entry)}`);
      }
    }
  }

  setupLogEntry(configurationId, playerIds) {
    return {
      setup: {
        variation: configurationId,
        players: playerIds
      }
    };
  }

  showMainMenu(anchor) {
    boundMethodCheck(this, App);
    this.setState({
      mainMenuAnchor: anchor
    });
  }

  showNewGameDialog() {
    boundMethodCheck(this, App);
    this.setState({
      newGameDialogOpen: true
    });
  }

  showImportDialog() {
    boundMethodCheck(this, App);
    this.setState({
      importDialogOpen: true
    });
  }

  showLog() {
    boundMethodCheck(this, App);
    this.setState({
      logDialogOpen: true
    });
  }

  showExportDialog() {
    boundMethodCheck(this, App);
    this.setState({
      exportDialogOpen: true
    });
  }

  showConfirmDialog(title, question, yesAction, noAction) {
    boundMethodCheck(this, App);
    this.setState({
      confirmDialog: {
        open: true,
        title,
        question,
        yesAction,
        noAction
      }
    });
  }

  showHandDialog() {
    boundMethodCheck(this, App);
    this.setState({
      handDialogOpen: true
    });
  }

  showSuggestDialog() {
    boundMethodCheck(this, App);
    this.setState({
      suggestDialogOpen: true
    });
  }

  showShowDialog() {
    boundMethodCheck(this, App);
    this.setState({
      showDialogOpen: true
    });
  }

  showAccuseDialog() {
    boundMethodCheck(this, App);
    this.setState({
      accuseDialogOpen: true
    });
  }

  showCommlinkDialog() {
    boundMethodCheck(this, App);
    this.setState({
      commlinkDialogOpen: true
    });
  }

  // Solver state updaters
  recordHand(playerId, cardIds) {
    if (this.solver != null) {
      this.solver.hand(playerId, cardIds);
      this.logHandEntry(playerId, cardIds);
    }
  }

  logHandEntry(playerId, cardIds) {
    this.setState(function(state, props) {
      return {
        log: state.log.concat([
          {
            hand: {
              player: playerId,
              cards: cardIds
            }
          }
        ])
      };
    });
  }

  recordSuggestion(suggesterId, cardIds, showedIds) {
    var id;
    if (this.solver != null) {
      id = this.suggestionId++;
      this.solver.suggest(suggesterId, cardIds, showedIds, id);
      this.logSuggestEntry(suggesterId, cardIds, showedIds, id);
    }
  }

  logSuggestEntry(suggesterId, cardIds, showedIds, id) {
    this.setState(function(state, props) {
      return {
        log: state.log.concat([
          {
            suggest: {
              id: id,
              suggester: suggesterId,
              cards: cardIds,
              showed: showedIds
            }
          }
        ])
      };
    });
  }

  recordShown(playerId, cardId) {
    if (this.solver != null) {
      this.solver.show(playerId, cardId);
      this.logShowEntry(playerId, cardId);
    }
  }

  logShowEntry(playerId, cardId) {
    this.setState(function(state, props) {
      return {
        log: state.log.concat([
          {
            show: {
              player: playerId,
              card: cardId
            }
          }
        ])
      };
    });
  }

  recordAccusation(accuserId, cardIds, outcome) {
    var id;
    if (this.solver != null) {
      id = this.accusationId++;
      this.solver.accuse(accuserId, cardIds, outcome, id);
      this.logAccuseEntry(accuserId, cardIds, outcome, id);
    }
  }

  logAccuseEntry(accuserId, cardIds, outcome, id) {
    this.setState(function(state, props) {
      return {
        log: state.log.concat([
          {
            accuse: {
              id: id,
              accuser: accuserId,
              cards: cardIds,
              outcome: outcome
            }
          }
        ])
      };
    });
  }

  recordCommlink(callerId, receiverId, cardIds, showed) {
    var id;
    if (this.solver != null) {
      id = this.commlinkId++;
      this.solver.commlink(callerId, receiverId, cardIds, showed, id);
      this.logCommlinkEntry(callerId, receiverId, cardIds, showed, id);
    }
  }

  logCommlinkEntry(callerId, receiverId, cardIds, showed, id) {
    this.setState(function(state, props) {
      return {
        log: state.log.concat([
          {
            commlink: {
              id: id,
              caller: callerId,
              receiver: receiverId,
              cards: cardIds,
              showed: showed
            }
          }
        ])
      };
    });
  }

  render() {
    return <div className="App">
      <MainView configurationId={this.state.configurationId} solver={this.solver} app={this} />
      <MainMenu anchor={this.state.mainMenuAnchor} started={this.solver != null} onClose={() => {
        return this.setState({
          mainMenuAnchor: null
        });
      }} app={this} />
      <SetupDialog open={this.state.newGameDialogOpen} configurations={configurations} onClose={() => {
        return this.setState({
          newGameDialogOpen: false
        });
      }} app={this} />
      <ImportDialog open={this.state.importDialogOpen} configurations={configurations} onClose={() => {
        return this.setState({
          importDialogOpen: false
        });
      }} app={this} />
      <LogDialog open={this.state.logDialogOpen} log={this.state.log} configurations={configurations} onClose={() => {
        return this.setState({
          logDialogOpen: false
        });
      }} app={this} />
      <ExportDialog open={this.state.exportDialogOpen} log={this.state.log} onClose={() => {
        return this.setState({
          exportDialogOpen: false
        });
      }} app={this} />
      <ConfirmDialog open={this.state.confirmDialog.open} title={this.state.confirmDialog.title} question={this.state.confirmDialog.question} yesAction={this.state.confirmDialog.yesAction} noAction={this.state.confirmDialog.noAction} onClose={this.handleConfirmDialogClose} app={this} />
      <HandDialog open={this.state.handDialogOpen} configuration={configurations[this.state.configurationId]} players={this.state.playerIds} onClose={() => {
        return this.setState({
          handDialogOpen: false
        });
      }} app={this} />
      <SuggestDialog open={this.state.suggestDialogOpen} configuration={configurations[this.state.configurationId]} players={this.state.playerIds} onClose={() => {
        return this.setState({
          suggestDialogOpen: false
        });
      }} app={this} />
      <ShowDialog open={this.state.showDialogOpen} configuration={configurations[this.state.configurationId]} players={this.state.playerIds} onClose={() => {
        return this.setState({
          showDialogOpen: false
        });
      }} app={this} />
      <AccuseDialog open={this.state.accuseDialogOpen} configuration={configurations[this.state.configurationId]} players={this.state.playerIds} onClose={() => {
        return this.setState({
          accuseDialogOpen: false
        });
      }} app={this} />
      <CommlinkDialog open={this.state.commlinkDialogOpen} configuration={configurations[this.state.configurationId]} players={this.state.playerIds} onClose={() => {
        return this.setState({
          commlinkDialogOpen: false
        });
      }} app={this} />
    </div>;
  }

  handleConfirmDialogClose() {
    boundMethodCheck(this, App);
    this.setState({
      confirmDialog: {
        open: false,
        title: "",
        question: "",
        yesAction: null,
        noAction: null
      }
    });
  }

};

export default App;
